module.exports = __webpack_public_path__ + "media/images/sac_logo_it-b1dfc9dc.svg";